module.exports = __webpack_public_path__ + "static/media/B6.7ca952c6.png";